import React from 'react';
import FormatStandardDate from './FormatStandardDate';

function convertYMDToISO(dateStr) {
  if (!dateStr || dateStr.length !== 8) return dateStr;
  return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`;
}

function getPatientAgeAtVaccination(dob, vaccinationDate) {
  if (!dob || !vaccinationDate) return "";

  // Convert 'yyyyMMdd' to 'YYYY-MM-DD'
  const dobISO = convertYMDToISO(dob);
  const vacISO = convertYMDToISO(vaccinationDate);

  const dobDate = new Date(dobISO);
  const vacDate = new Date(vacISO);

  if (isNaN(dobDate.getTime()) || isNaN(vacDate.getTime())) {
    return "";
  }

  let years = vacDate.getFullYear() - dobDate.getFullYear();
  let months = vacDate.getMonth() - dobDate.getMonth();
  let days = vacDate.getUTCDate() - dobDate.getUTCDate();

  if (days < 0) {
    months -= 1;
    days += new Date(vacDate.getFullYear(), vacDate.getMonth(), 0).getUTCDate();
  }
  if (months < 0) {
    years -= 1;
    months += 12;
  }

  if (years < 1) {
    // Under 1 year: show in months
    return `${months} month${months !== 1 ? 's' : ''}`;
  } else if (years < 4) {
    // Under 4 years: show in years, months
    let ageStr = `${years} year${years !== 1 ? 's' : ''}`;
    if (months > 0) {
      ageStr += `, ${months} month${months !== 1 ? 's' : ''}`;
    }
    return ageStr;
  } else {
    // 4 years or older: show in years
    return `${years} year${years !== 1 ? 's' : ''}`;
  }
}

export const VaccinationTable = (props) => {
  const rowEntries = props.vaccinationList;
  const patientDob = props.patientDob;
  console.log('Patient DOB:', patientDob);

  const content = (rowEntries === [] || rowEntries === undefined) ? (<></>) :
    (
      <>
        <h4>Vaccination List</h4>
        <table className='table table-striped' aria-labelledby="tabelLabel">
          <thead>
            <tr>
              <th>Vaccine Name</th>
              <th>Date</th>
              <th>PatientAge</th>
              <th>Valid</th>
              <th>Cvx Code</th>
              <th>Lot Number</th>
              <th>Mfg Code</th>
              <th>Provider</th>
            </tr>
          </thead>
          <tbody>
            {rowEntries.map((row, index) =>
              row.antigenList.reduce(
                (previousValue, currentValue) => previousValue === (currentValue.evaluationStatus === 'valid' || currentValue.evaluationStatus === 'extraneous'),
                true) === false
                ?
                <tr key={index}>
                  <td><span className="text-danger">{row.vaccineName}</span></td>
                  <td><span className="text-danger">{FormatStandardDate(row.vaccinationDate)}</span></td>
                  <td><span className="text-danger">{getPatientAgeAtVaccination(patientDob, row.vaccinationDate)}</span></td>
                  <td><span className="text-danger">{row.antigenList.reduce(
                    (previousValue, currentValue) => previousValue === (currentValue.evaluationStatus === 'valid' || currentValue.evaluationStatus === 'extraneous'),
                    true).toString()}
                  </span></td>
                  <td><span className="text-danger">{row.cvxCode}</span></td>
                  <td><span className="text-danger">{row.lotNumber}</span></td>
                  <td><span className="text-danger">{row.manufacturerCode}</span></td>
                  <td><span className="text-danger">{(row.provider !== null) ? row.provider.name : "not available"}</span></td>
                </tr>
                :
                <tr key={index}>
                  <td>{row.vaccineName}</td>
                  <td>{FormatStandardDate(row.vaccinationDate)}</td>
                  <td>{getPatientAgeAtVaccination(patientDob, row.vaccinationDate)}</td>
                  <td>{row.antigenList.reduce(
                    (previousValue, currentValue) => previousValue === (currentValue.evaluationStatus === 'valid' || currentValue.evaluationStatus === 'extraneous'),
                    true).toString()}
                  </td>
                  <td>{row.cvxCode}</td>
                  <td>{row.lotNumber}</td>
                  <td>{row.manufacturerCode}</td>
                  <td>{(row.provider !== null) ? row.provider.name : "not available"}</td>
                </tr>
            )}
          </tbody>
        </table>
      </>
    )

  return content;
}
